import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as filledStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as emptyStar } from "@fortawesome/free-regular-svg-icons";

const Testimonials = () => {
  // State to manage the visibility of additional testimonials
  const [showMore, setShowMore] = useState(false);

  const testimonials = [
    {
      text: "Great service from Justin and Phillip going out of there way to assist me with my car trouble. I highly recommend them to anyone looking for parts and advice. Best service that I've had in ages. Keep up the great work guys👏",
      name: "Paul Weitsz",
      rating: 5,
    },
    {
      text: "Absolutely best service. Thank you for always friendly and helpful. They walk the extra mile for clients. Thank you, Andre.",
      name: "Corrie von Wielllogh",
      rating: 5,
    },
    {
      text: "These people understand their customers' needs, they are effective, efficient, and very competent in their jobs. Their staff are very friendly and very helpful. I will definitely visit again. Thank you, Richard!!",
      name: "Pieter Kruger",
      rating: 5,
    },
    {
      text: "The staff at Imperium Auto Spares are first class. Zandre, Quintin, Eddie, Papers to name a few really look after our needs; they go above and beyond the call of duty. True professionals and top-class service.",
      name: "Kuvenderen Govender",
      rating: 5,
    },
    {
      text: "Very friendly staff, I'm happy always buying parts at Imperium for my ford figo and now assisted by Justin also great service I highly recommend 👌",
      name: "Andisiwe Tokwe",
      rating: 5,
    },
    {
      text: "Big shout out to Leon, thank you for going the extra mile to help me out. This is the place to go, Thank you Mr Richard T Maré. You have a great team member.",
      name: "Felix Vosloo",
      rating: 5,
    },
  ];

  const displayedTestimonials = showMore
    ? testimonials
    : testimonials.slice(0, 3);

  return (
    <section className="py-16 bg-gray-100">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">
        What Our Customers Say
      </h2>
      <div className="container mx-auto flex flex-col space-y-6">
        {displayedTestimonials.map((testimonial, index) => (
          <div
            key={index}
            className="testimonial bg-white p-6 rounded-lg shadow-lg transition-transform duration-200 transform hover:scale-105"
          >
            <div className="flex items-center mb-2">
              {/* Display filled stars for the rating */}
              {[...Array(testimonial.rating)].map((_, starIndex) => (
                <FontAwesomeIcon
                  key={`filled-${starIndex}`}
                  icon={filledStar}
                  className="text-yellow-400 text-lg"
                />
              ))}
              {/* Display empty stars for the remaining */}
              {[...Array(5 - testimonial.rating)].map((_, emptyStarIndex) => (
                <FontAwesomeIcon
                  key={`empty-${emptyStarIndex}`}
                  icon={emptyStar}
                  className="text-gray-300 text-lg"
                />
              ))}
            </div>
            <p className="italic text-gray-700 mb-2">"{testimonial.text}"</p>
            <p className="mt-3 font-semibold text-gray-900">
              - {testimonial.name}
            </p>
          </div>
        ))}
      </div>
      <div className="flex justify-center mt-4">
        <button
          onClick={() => setShowMore((prev) => !prev)}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition duration-200"
        >
          {showMore ? "Show Less" : "Show More"}
        </button>
      </div>
    </section>
  );
};

export default Testimonials;
